import { Route, Location } from "vue-router/types/router.d";

import store from "@/store";
import router from "@/router";
import { hasToken } from "@/helpers/auth-helper";
import { isNotNullOrUndefined, Overwrite } from "./type-helper";
import {
  TERMS_OF_USE_FOR_JOB_NAME,
  TERMS_OF_USE_FOR_PLAN_NAME,
  TERMS_OF_USE_FOR_SCOUT_NAME,
  TERMS_OF_OUTSOURCING_NAME,
  EXTERNAL_DATA_PROCESSORS
} from "@/constants/terms";

export type RouterLocation = Overwrite<Location, { name: string }>;

export const redirectToInitialPage = (to: Route): boolean => {
  const redirectTo = to.query["redirectTo"];
  const fixedRedirectTo =
    (redirectTo &&
      typeof redirectTo === "string" &&
      redirectTo.replace(/[\t\n\r]/g, "").replace(/[/\\]+/g, "/")) ||
    "";
  const routerResolved = router.resolve({ path: fixedRedirectTo });
  const errorRoute = routerResolved.resolved.name === "Error";

  if (fixedRedirectTo && !errorRoute && !to.meta?.authPage) {
    router.replace({ path: fixedRedirectTo }).catch(err => err);
    return true;
  }

  if (!to.meta?.ignoreAuth && !hasToken()) {
    router
      .replace({
        name: "SignIn",
        query: { redirectTo: to.fullPath }
      })
      .catch(err => err);
    return true;
  }

  return false;
};

export const redirectWhenIsNotOnboardingFinished = (): boolean => {
  const currentPath = router.currentRoute.path;
  const isHomeRoute =
    router.resolve({ path: currentPath }).resolved.name === "Home";

  // 利用規約ページはリダイレクトさせない
  const isTermsPage = [
    TERMS_OF_USE_FOR_JOB_NAME,
    TERMS_OF_USE_FOR_PLAN_NAME,
    TERMS_OF_USE_FOR_SCOUT_NAME,
    TERMS_OF_OUTSOURCING_NAME,
    EXTERNAL_DATA_PROCESSORS
  ].includes(router.resolve({ path: currentPath }).resolved.name || "");

  if (isHomeRoute || isTermsPage) return false;

  const partnerUser = store.state.domains.user.partnerUser;

  // 代理ログインの場合はリダイレクトさせない
  if (partnerUser?.logged_in_by_proxy === false) return false;

  const isOnboardingFinished = partnerUser?.onboarding_finished;

  if (isOnboardingFinished !== undefined && !isOnboardingFinished) {
    router.push({ name: "Home" }).catch(err => err);
    return true;
  }

  return false;
};

// Note: 配列を想定するVueRouterの配列数が1つの場合、stringが返ってくるため、string[]に変換する。
export const pathQueryValueToArray = <T extends string>(
  query: Route["query"][string]
): T[] | undefined => {
  return query
    ? Array.isArray(query)
      ? (query.filter(isNotNullOrUndefined) as T[])
      : ([query] as T[])
    : undefined;
};
